<sirius-container>
    <div class="sir-media-collage-grid">
        @for (item of resolvedItems(); track $index) {
            <sirius-image-item
                class="sir-media-collage-item"
                [image]="thumbnails()[$index]"
                [imageData]="getImageData($index)"
                [autocrop]="true"
                objectFit="cover"
                tabindex="0"
                role="button"
                [attr.aria-label]="item.title || 'Open media item'"
                (click)="onClick($index)"
                (keydown.enter)="onClick($index)"
                (keydown.space)="$event.preventDefault(); onClick($index)"
                (mouseenter)="onMouseEnter($index)"
                (mouseleave)="onMouseLeave()">
                @if (item.type === 'video') {
                    <sirius-play-button [hovered]="hoveredIndex() === $index" [focusable]="false"></sirius-play-button>
                }
            </sirius-image-item>
        }
    </div>
</sirius-container>

@if (open()) {
    <sirius-media-collection-modal
        [items]="resolvedItems()"
        [startIndex]="index()"
        (closeEvent)="onClose()"
        [showDescription]="showDescription()">
    </sirius-media-collection-modal>
}
